export default __webpack_public_path__ + "static/media/nft-2@2x.2151bf96.png";